
import React from "react";

import {
  MessageCircle,
  Phone,
} from "lucide-react";

import {
  WHATSAPP_URL,
  TEL_URL,
} from "@/lib/brand";

export default function MobileStickyCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-[var(--gf-border)] bg-white/95 backdrop-blur-xl p-3">

      <div className="grid grid-cols-2 gap-3">

        {/* WhatsApp */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-[var(--gf-green)] hover:bg-[var(--gf-green-deep)] text-white font-semibold h-12 rounded-2xl shadow-lg transition-all"
        >

          <MessageCircle className="h-5 w-5" />

          WhatsApp
        </a>

        {/* Call */}
        <a
          href={TEL_URL}
          className="inline-flex items-center justify-center gap-2 bg-[var(--gf-primary)] hover:bg-slate-800 text-white font-semibold h-12 rounded-2xl shadow-lg transition-all"
        >

          <Phone className="h-5 w-5" />

          Call Now
        </a>
      </div>
    </div>
  );
}
